import React, { useCallback, useState } from "react";
import CardEndereco from "../../CardEndereco";
import CardOutrasInformacoes from "./CardOutrasInformacoes";
import { Button } from "../../../../../components";
import ConfirmarDialog from "../../ConfirmarDialog";

const ImovelForm = ({
  formProps,
  dominioUfs,
  handleZipCodeBlur,
  handleSubmit,
  submitting,
  disabled,
  filtrarCartorios,
  dominioCartorios,
  handleGoBack,
}) => {
  const [open, setOpen] = useState(false);
  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleClickNext = useCallback(
    (values) => {
      handleCloseDialog();
      handleSubmit(values, formProps.initialValues);
    },
    // eslint-disable-next-line
    [handleSubmit, handleCloseDialog]
  );

  if (Object.keys(formProps.errors).length > 0 && open) {
    setOpen(false);
  }

  return (
    <form
      className="d-flex flex-column"
      onSubmit={formProps.handleSubmit(handleClickNext)}
    >
      <CardEndereco
        title="Endereço do Imóvel"
        props={formProps}
        disabled={disabled}
        uf={dominioUfs}
        consultarCep={handleZipCodeBlur}
        filtrarCartorios={filtrarCartorios}
      />
      <CardOutrasInformacoes
        props={formProps}
        disabled={disabled}
        dominioCartorios={dominioCartorios}
      />
      <div className="row spacer justify-content-center">
        <div className="col-md-4 col-5">
          <Button
            label="VOLTAR"
            loading={submitting}
            onClick={() => handleGoBack()}
          />
        </div>
        {!disabled && (
          <div className="col-md-4 col-5">
            <Button
              label="ATUALIZAR"
              loading={submitting}
              onClick={() => {
                setOpen(true);
                formProps.clearErrors();
              }}
            />
          </div>
        )}
      </div>
      <ConfirmarDialog open={open} handleClose={handleCloseDialog} />
    </form>
  );
};

export default ImovelForm;
